export { default as GDMLoading } from './GDMLoading';

export { GDMLoadingType } from './GDMLoading.type';

export type {
  GDMLoadingComponent,
  GDMLoadingComponentProps,
  IGDMLoadingProps,
} from './GDMLoading.type';
